import { Classes, Menu, MenuDivider, MenuItem } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import classNames from 'classnames';
import * as React from 'react';

import { Dialog } from 'src/ui/components/Dialog';
import { Connection } from 'src/ui/features/connection';
import { graphQLClient } from 'src/ui/graph/graphQLClient';
import { useUserPartnerConnectionsQuery } from 'src/ui/graph/types';
import {
  useNavigateToConnection,
  useNavigateToPartnerConnection,
} from 'src/ui/hooks/connection';
import * as copy from 'src/ui/templates/copy';
import { doServiceRedirect } from 'src/ui/utils/window';

interface SelectConnectionDialogProps {
  connections: Connection[];
  redirectSubPath?: string;
  isOpen: boolean;
}

export const SelectConnectionDialog: React.VFC<SelectConnectionDialogProps> = ({
  connections,
  redirectSubPath,
  isOpen,
}) => {
  const { data: partnerInfo } = useUserPartnerConnectionsQuery(graphQLClient);
  const navigateToConnection = useNavigateToConnection();
  const navigateToPartnerConnection = useNavigateToPartnerConnection();

  const { endpoint } = connections[0];

  const onSelect = (index?: number) => {
    if (index === undefined) {
      return;
    }

    if (redirectSubPath) {
      doServiceRedirect(index, redirectSubPath);
      return;
    }

    if (partnerInfo?.userPartnerConnections?.length) {
      navigateToPartnerConnection(`/databricks-partner-home`);
      return;
    }

    navigateToConnection(index);
  };

  return (
    <Dialog
      icon={IconNames.OFFLINE}
      title={copy.components.connectionDialog.select.title}
      className={classNames('sd-dialog-connection')}
      isCloseButtonShown={false}
      canOutsideClickClose={false}
      canEscapeKeyClose={false}
      isOpen={isOpen}
    >
      <div className={Classes.DIALOG_BODY}>
        <Menu large>
          <MenuDivider title={endpoint} />
          {connections.map((conn) => (
            <MenuItem
              key={conn.index}
              icon={IconNames.OFFLINE}
              onClick={() => onSelect(conn.index)}
              text={conn.name}
            />
          ))}
        </Menu>
      </div>
    </Dialog>
  );
};
